import { CalendarBlank, TrendUp, TrendDown } from "@phosphor-icons/react";

const DEFS = {
  recovery: { label: "Восстановление", unit: "%", goodUp: true },
  hrv: { label: "HRV", unit: "мс", goodUp: true },
  rhr: { label: "Пульс покоя", unit: "уд/мин", goodUp: false },
  sleep_h: { label: "Сон", unit: "ч", goodUp: true },
  strain: { label: "Нагрузка", unit: "", goodUp: null },
  kcal: { label: "Калории", unit: "ккал", goodUp: null },
};
const MONTHS = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];
const fmtD = (iso) => `${parseInt(iso.slice(8, 10), 10)} ${MONTHS[parseInt(iso.slice(5, 7), 10) - 1]} ${iso.slice(0, 4)}`;

export default function YearCompareCard({ compare }) {
  if (!compare) return null;
  return (
    <div className="glass-card p-5" data-testid="year-compare-card">
      <div className="flex items-center gap-2 mb-1">
        <CalendarBlank size={18} weight="fill" className="text-primary" />
        <h3 className="text-sm font-semibold">Вы сейчас vs вы год назад</h3>
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        Последние 30 дней против {fmtD(compare.ya_start)} — {fmtD(compare.ya_end)}.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
        {compare.metrics.map((m) => {
          const def = DEFS[m.key] || { label: m.key, unit: "", goodUp: null };
          const up = m.delta_pct >= 0;
          const good = def.goodUp == null ? null : def.goodUp === up;
          const col = good == null ? "text-muted-foreground" : good ? "text-[#00e676]" : "text-[#ff3b30]";
          return (
            <div key={m.key} className="rounded-md bg-secondary/40 p-3" data-testid={`year-compare-${m.key}`}>
              <div className="text-[10px] uppercase tracking-wider text-muted-foreground mb-1">{def.label}</div>
              <div className="flex items-baseline gap-1.5 flex-wrap">
                <span className="num font-bold text-sm">{m.current}{def.unit && ` ${def.unit}`}</span>
                <span className={`num text-[11px] flex items-center gap-0.5 ${col}`}>
                  {up ? <TrendUp size={11} /> : <TrendDown size={11} />}{up ? "+" : ""}{m.delta_pct}%
                </span>
              </div>
              <div className="text-[10px] text-muted-foreground num mt-0.5">год назад: {m.year_ago}{def.unit && ` ${def.unit}`}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
